import { isNil, omitBy } from 'lodash';

import { _QueryResources } from '@/lib/datx-jsonapi-react';
import { LecturePackages } from '@/resources/LecturePackages';

export const queryAllLecturePackages = (filters = {}): _QueryResources<LecturePackages> => {
  return [
    LecturePackages,
    {
      filter: omitBy(
        {
          filters,
        },
        isNil
      ),
      loadAll: true,
    },
  ];
};
